import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import EChartsBarChart from "../Masters/EChartsBarChart";
import ActiveProjects from "./ActiveProject";
import { ContentLoader } from "../../Components/Shimmer";
import { getTimeOfDay } from "../../Components/GlobalFunctions";
import RequestPieChart from "./RequestPieChart";
import TaskManagement from "./TaskManagement";

const Dashboard = () => {

  const [projectRequests, setProjectRequests] = useState([]);
  const [DashboardData, setDashboardData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);

  const getDashboardData = async () => {
    try {
      setLoadingList(true);
      const response = await axios.get(
        `${apiURL}api/GetDashboardForConsultant`,
        {
          params: { consultant_id: user_profile_id },
          headers: apiHeaderJson,
        }
      );

      setDashboardData(response.data.data.tabs);
      setProjectRequests(response.data?.data?.tabs?.projects_requests)

    } catch (error) {
      console.log(error);
    } finally {
      setLoadingList(false);
    }
  };

  const pendingRequests = projectRequests.filter(row => row.request_status === 0).length;

  useEffect(() => {
    getDashboardData();
  }, []);

  // 🎉 CARDS ARRAY
  const cards = [
    {
      title: "Total Projects",
      count: DashboardData?.total_projects?.length ?? 0,
      link: "/AllProjects",
      icon: "ri-building-2-line",
      bg: "bg-info-subtle",
      textColor: "text-info",
    },
    {
      title: "Completed Projects",
      count: DashboardData?.total_completed_projects?.length ?? 0,
      link: "/CompletedProjects",
      icon: "ri-checkbox-circle-line",
      bg: "bg-success-subtle",
      textColor: "text-success",
    },
    {
      title: "Active Projects",
      count: DashboardData?.total_pending_projects?.length ?? 0,
      link: "/PendingProjects",
      icon: "ri-building-3-line",
      bg: "bg-warning-subtle",
      textColor: "text-warning",
    },
    {
      title: "Pending Request",
      count: pendingRequests ?? 0,
      link: "/PendingRequests",
      icon: "bx bx-hourglass",
      bg: "bg-danger-subtle",
      textColor: "text-danger",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-content">
        {loadingList ? (
          <ContentLoader />
        ) : (
          <div className="container-fluid">
            {/* Greeting Header */}
            <div className="row mb-3 pb-1">
              <div className="col-12">
                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                  <div className="flex-grow-1">
                    <h4 className="fs-16 mb-1">
                      {getTimeOfDay()}, Consultant !
                    </h4>
                    <p className="text-muted mb-0">
                      Here's what's happening with your store today.
                    </p>
                  </div>

                  <div className="mt-3 mt-lg-0">
                    <NavLink to={"/ViewAllRequest"} className="btn btn-soft-dark">
                      <i className="ri-eye-line align-middle me-1" />
                      View New Request
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>

            {/* ⭐ STAT CARDS (ARRAY GENERATED) */}
            <div className="row">
              {cards.map((card, index) => (
                <div key={index} className="col-xl-3 col-md-6">
                  <div className="card card-animate">
                    <div className="card-body">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {card.title}
                      </p>

                      <div className="d-flex align-items-end justify-content-between mt-4">
                        <div>
                          <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                            {card.count}
                          </h4>
                          <Link
                            to={card.link}
                            className="text-decoration-underline text-muted"
                          >
                            See {card.title}
                          </Link>
                        </div>

                        <div className="avatar-sm flex-shrink-0">
                          <span className={`avatar-title ${card.bg} rounded fs-3`}>
                            <i className={`${card.icon} ${card.textColor}`} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              <TaskManagement />
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <ActiveProjects />
                </div>
              </div>
              {/* <div className="col-xl-5">
                <RequestPieChart />
              </div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
